<template>
  <div class="label-button button" :disabled="hasDisabledAttr" @click="handleClick">
    <slot name="icon" />
    <span class="label"><slot name="label" /></span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Props
interface Props {
  disabled?: boolean;
}

const { disabled = false } = defineProps<Props>();

// Emits
const emit = defineEmits<{
  click: [data: unknown];
}>();

// Computed
const hasDisabledAttr = computed(() => {
  return disabled ? true : null;
});

// Methods
const handleClick = (value) => {
  if (!disabled) {
    emit("click", value);
  }
};
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.label-button {
  display: flex;
  align-items: center;
  cursor: pointer;

  &[disabled],
  .disabled {
    .sls-icon {
      [stroke] {
        stroke: $disabled-02;
      }

      [fill] {
        fill: $disabled-02;
      }
    }

    .label {
      color: $disabled-02;
    }
  }

  .sls-icon {
    margin-right: $spacing-03;

    [stroke] {
      stroke: $interactive-01;
    }

    [fill] {
      fill: $interactive-01;
      &[fill="#fff"] {
        fill: $icon-03;
      }
    }
  }

  .label {
    @include carbon--type-style("button-01", true);
    color: $link-01;
  }
}
</style>
